import NarrowEmptyItemCard from './narrowEmptyItemCardContainer'

export default NarrowEmptyItemCard
